module.exports = __webpack_public_path__ + "static/media/Rectangle_Light.b1b60fbc.svg";